<template>
  <v-dialog
    transition="scale-transition"
    content-class="show-modal-popup"
    :scrim="'#212121'"
    :opacity="0.65"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="pa-5 dialog show-modal-popup show-modal-popup__card">
      <h3 class="flex-grow-1 text-center mb-2">
        You have items in your cart
      </h3>
      <v-card-text class="px-0 text-center">
        Would you like to remove these items and continue with a new item in
        your cart?
      </v-card-text>
      <v-btn
        class="mb-3 show-modal-popup__btn"
        color="primary"
        rounded
        size="large"
        variant="flat"
        width="100%"
        @click="
          $emit('close-dialog');
          $emit('remove-item');
        "
      >
        Yes
      </v-btn>
      <v-btn
        rounded
        class="show-modal-popup__btn show-modal-popup__btn-cancel"
        color="surface-variant"
        size="large"
        variant="outlined"
        width="100%"
        @click="
          $emit('close-dialog');
          $router.go(-1);
        "
      >
        Take me back
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ExistingOrderModal',
  props: {
    modelValue: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.v-card-text) {
  color: rgba(0, 0, 0, .6) !important;
  padding-top: 6px !important;
  padding-bottom: 20px !important;
  font-size: 0.875rem !important;
}
.v-btn--icon.v-btn--density-default {
    width: 32px;
    height: 32px;
}

.v-dialog {
    width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    width: 100%;
}

.show-modal-popup {  
  &__card {
    max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
    max-height: 94%;
    margin: 0;
    border-radius: 2rem !important;
  }

  h3 {  
    font-size: 1.25rem !important;
    line-height: 1.5625rem!important;
    padding-bottom: 0px;
  }
}

:deep(.v-overlay__content) {  
  max-height: calc(100vh - 48px);
  max-width: min(480px, calc(100vw - 48px));
}

:deep(.show-modal-popup__btn-cancel) {
  color: rgba(0, 0, 0, .9) !important;
}
</style>